// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__mg-DO","onDark":"Tag_onDark__XegH4"};